import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { anchorLinkScroll, slugify } from '../../utils';
import ThemeContext from '../../context/ThemeContext';
import * as styles from './AnchorLinks.module.scss';

const AnchorLinks = ({ items }) => {
  const { navWide } = useContext(ThemeContext);

  const handleClick = (e) => {
    e.preventDefault();
    const selector = e.target.hash;
    const targetElement = document.querySelector(selector);
    if (targetElement) {
      window.location.hash = selector.substring(1); // update URL for a11y
      anchorLinkScroll(targetElement, navWide);
    }
  };

  return (
    <>
      <nav className={styles.anchorLinks}>
        <ul>
          {items &&
            items.map(({ title }) => (
              <li key={title}>
                <a href={`#${slugify(title)}`} onClick={handleClick}>
                  {title}
                </a>
              </li>
            ))}
        </ul>
      </nav>
      {items &&
        items.map(({ title, content }) => (
          <div key={title}>
            <h3 id={slugify(title)}>{title}</h3>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        ))}
    </>
  );
};

AnchorLinks.propTypes = {
  items: PropTypes.array
};

export default AnchorLinks;
